"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _TextField = _interopRequireDefault(require("@eig-builder/core-ui/TextField"));

var _Button = _interopRequireDefault(require("@eig-builder/core-ui/Button"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _imageLibraryHelper = require("../helpers/image-library-helper");

var _useResponsiveQuery = require("@eig-builder/core-utils/hooks/useResponsiveQuery");

var _imageValidation = require("../helpers/image-validation");

var _withContext = _interopRequireDefault(require("../helpers/with-context"));

require("../lang");

require("./style/add-from-link.scss");

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

var _recoil = require("recoil");

var _store = require("../store");

var _templateObject;

var AddFromUrlField = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: space-between;\n"])));

var AddFromLink = function AddFromLink(_ref) {
  var onSelectionChanged = _ref.onSelectionChanged,
      toggleLoading = _ref.toggleLoading,
      tags = _ref.tags;

  var _useRecoilState = (0, _recoil.useRecoilState)(_store.loadingState),
      _useRecoilState2 = (0, _slicedToArray2["default"])(_useRecoilState, 1),
      loading = _useRecoilState2[0].loading;

  var _React$useState = _react["default"].useState(''),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      currentValue = _React$useState2[0],
      setCurrentValue = _React$useState2[1];

  var isMobile = (0, _useResponsiveQuery.useIsMobile)();

  var _React$useState3 = _react["default"].useState({
    errors: [],
    show: false
  }),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      errors = _React$useState4[0],
      setErrors = _React$useState4[1];

  var showError = function showError(errors) {
    if (Array.isArray(errors)) {
      var convertedErrors = (0, _imageValidation.validationErrorsToTextComponent)(errors);
      setErrors({
        errors: convertedErrors,
        show: true
      });
    } else {
      throw new Error('ShowError takes a array');
    }
  };

  var save = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(e) {
      var uriToFile, imageValidated, query, imageUrl, publicUrl;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setErrors({
                errors: [],
                show: false
              });

              if (!(currentValue.indexOf('//') > -1)) {
                _context.next = 19;
                break;
              }

              toggleLoading(true);
              _context.next = 5;
              return (0, _imageLibraryHelper.convertUriToFile)(currentValue);

            case 5:
              uriToFile = _context.sent;

              if (!uriToFile.error) {
                _context.next = 10;
                break;
              }

              toggleLoading(false);
              _context.next = 19;
              break;

            case 10:
              _context.next = 12;
              return (0, _imageValidation.ImageValidation)(uriToFile)["catch"](function (errors) {
                showError(errors);
                toggleLoading(false);
              });

            case 12:
              imageValidated = _context.sent;

              if (!(imageValidated && imageValidated.success)) {
                _context.next = 19;
                break;
              }

              query = (0, _imageLibraryHelper.convertTagsToQueryParams)(tags);
              _context.next = 17;
              return (0, _imageLibraryHelper.storeImageFromUrl)(currentValue, uriToFile.name, query);

            case 17:
              imageUrl = _context.sent;

              if (imageUrl.error) {
                showError(imageUrl.error);
                toggleLoading(false);
              } else {
                publicUrl = imageUrl.public_url;
                toggleLoading(false);
                onSelectionChanged({
                  source: 'uploads',
                  original: publicUrl
                }, '', true);
              }

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function save(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onChange = function onChange(e) {
    return setCurrentValue(e.target.value);
  };

  var addFromLinkClass = (0, _classnames["default"])('add-from-link', {
    mobile: isMobile
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: addFromLinkClass
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "title"
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2"
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.enterLink"
  }))), /*#__PURE__*/_react["default"].createElement(AddFromUrlField, null, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    className: "input",
    fullWidth: true,
    variant: "outlined",
    placeholder: "Add from link",
    onChange: onChange,
    name: "add-from-link-field",
    value: currentValue
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "input-field--input-button",
    color: "primary",
    tag: "image-picker-add-from-link-save-button",
    onClick: function onClick(e) {
      return save(e);
    },
    disabled: loading,
    dataElementLabel: "image-selector--upload--add-from-link",
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementId: "image-selector--upload--add-from-link"
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.save"
  }))), /*#__PURE__*/_react["default"].createElement("div", null, errors && errors.show && errors));
};

AddFromLink.propTypes = {
  onSelectionChanged: _propTypes["default"].func.isRequired,
  tags: _propTypes["default"].object,
  toggleLoading: _propTypes["default"].func.isRequired
};

var _default = (0, _withContext["default"])(AddFromLink);

exports["default"] = _default;